module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/career-listing-20bac18afc2b37c8e5f2debc4ed8aee0.jpg";